import { TableUI } from "components/design/TableUI";
import Table from "components/DesignSystem/Table/V2/Table";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { BroadcastchannelResponse } from "types/Models/broadcast";

const createColumn = createColumnHelper<BroadcastchannelResponse>();

const columns = [
  createColumn.accessor("group_name", {
    header: "GROUP",
    size: 40,
    cell: (info) => (
      <div className="t-text-body-sm t-text-text-60 t-line-clamp-1">
        {info.getValue()}
      </div>
    ),
  }),
  createColumn.accessor("company_entity.name", {
    header: "ENTITY",
    size: 30,
    cell: (info) => (
      <div className="t-text-body-sm t-text-text-60 t-line-clamp-1">
        {info.getValue()}
      </div>
    ),
  }),
  createColumn.accessor("name", {
    header: "CHANNEL",
    size: 30,
    cell: (info) => (
      <div className="t-text-body-sm t-text-text-30 t-line-clamp-1">
        {info.getValue()}
      </div>
    ),
  }),
];

export const BroadcastMessageChannelTable = ({
  channels,
}: {
  channels: BroadcastchannelResponse[];
}) => {
  const table = useReactTable({
    data: channels,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <TableUI table={table} size="regular" height="240px" />;
};
